import { render, staticRenderFns } from "./Rakamlar.vue?vue&type=template&id=d872972e&scoped=true&"
import script from "./Rakamlar.vue?vue&type=script&lang=js&"
export * from "./Rakamlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d872972e",
  null
  
)

export default component.exports